// src/components/LichessTeamBattleInfo.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const LichessTeamBattleInfo = () => {
  // Styles: black box with orange border, same vibe as your Chess Club section
  const box = {
    background: "#0f0f0f",
    border: "1px solid #ff7a18",
    borderRadius: 12,
    color: "#e6e6e6",
    padding: 16,
    maxWidth: 1200,
    margin: "0 auto 24px auto",
  };

  const title = {
    color: "#eaeaea",
    fontSize: "1.35rem",
    fontWeight: 800,
    textAlign: "center",
    margin: "6px 0 12px",
  };

  const desc = {
    fontSize: "1rem",
    lineHeight: 1.55,
    color: "#d2d2d2",
  };

  const imgStyle = {
    width: "100%",
    height: "auto",
    display: "block",
    borderRadius: 8,
  };

  return (
    <div style={box}>
      <Container fluid className="p-0">
        <h2 style={title}>Monthly Lichess Team Battle</h2>

        <Row className="g-3 align-items-start">
          {/* Picture: on mobile it appears first; on desktop it's on the right */}
          <Col
            xs={12}
            md={{ span: 5, order: 2 }}
            className="order-1 order-md-2"
          >
            <img
              src="teambattle.png" // <-- replace with your image path
              alt="Lichess Team Battle arena"
              style={imgStyle}
            />
          </Col>

          {/* Description */}
          <Col
            xs={12}
            md={{ span: 7, order: 1 }}
            className="order-2 order-md-1"
          >
            <div style={desc}>
              <p>
                A Lichess <strong>Team Battle</strong> is a special kind of
                <em> Arena</em> tournament where multiple chess clubs compete at
                the same time. Everyone who joins plays continuous games during
                a fixed time window (for example, 60–120 minutes). As soon as
                you finish one game, Lichess pairs you again so you can keep
                scoring for your club. There is no elimination, just keep
                playing and collecting points until the arena ends.
              </p>

              <p>
                The scoring follows standard Arena rules: a win gives points.
                After you string together two wins, you activate a{" "}
                <strong>streak bonus</strong> subsequent wins are worth extra
                (double) points until you draw or lose. You can also choose to{" "}
                <strong>berserk</strong> in the opening seconds of a game: your
                clock time is reduced (and increment removed), but if you still
                win you earn a small bonus point. Use berserk wisely; it’s great
                when you’re up for a fast, sharp game and want to maximise your
                score.
              </p>

              <p>
                What makes it a <em>team</em> event is how the final score is
                calculated. Each club’s total is the sum of its top performers,
                commonly the best
                <strong> 10 scorers</strong> (the organiser can set this
                number). That means a big turnout helps: even if you don’t end
                up in the top scorers, your wins reduce opponents’ points and
                help your teammates climb. Every game matters. Typical time
                controls are blitz (e.g., 3+2 or 5+0), but the organiser chooses
                the exact settings, including variant (usually standard chess),
                arena duration, and whether streaks/berserk are enabled.
              </p>

              <p>
                To take part, log in to your Lichess account, make sure you’ve
                joined your club’s Lichess team, and open the tournament link
                before it starts. Click <strong>Join</strong> and you’re in.
                When the arena goes live, play as many games as you comfortably
                can. Quick practical tips: start on time to maximise pairings,
                avoid long think-stalls (you want more games), and focus on
                solid, simple chess, safe openings, quick development, and
                staying alert for tactics. Check your club’s calendar for the
                next Monthly Team Battle date and time, and jump in your points
                could be the ones that tip the match in your team’s favour.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LichessTeamBattleInfo;
